import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {
    akf,
    akfLangzeitmiete,
    arval,
    ass,
    athlon,
    ayvens,
    controlExpert,
    dbconnect,
    de_DE_formal,
    de_DE_informal,
    deutscheleasing,
    ego,
    finn,
    fleethub,
    generalmotors,
    leasePlan,
    meinauto,
    mobexo,
    mobilityConcept,
    nio,
    repareo,
    signaliduna,
    vehiClever,
} from "@App/locales";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    arval: arval,
    akf: akf,
    akfLangzeitmiete: akfLangzeitmiete,
    repareo: repareo,
    dbconnect: dbconnect,
    finn: finn,
    ego: ego,
    deutscheleasing: deutscheleasing,
    fleethub: fleethub,
    de_DE_formal: de_DE_formal,
    de_DE_informal: de_DE_informal,
    mobilityConcept: mobilityConcept,
    nio: nio,
    meinauto: meinauto,
    controlExpert: controlExpert,
    leasePlan: leasePlan,
    generalmotors: generalmotors,
    vehiclever: vehiClever,
    ass: ass,
    ayvens: ayvens,
    athlon: athlon,
    mobexo: mobexo,
    signaliduna: signaliduna
};

i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources,
        fallbackLng: 'de_DE_formal',
        debug: false,

        // // have a common namespace used around the full app
        // ns: ["hero", "welcomeModal", "translation"],
        // defaultNS: "translation",

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });


export default i18n;
